import { journeyAction, } from './base';

import { JourneyActionOperationalHours as JourneyActionOperationalHoursBase, } from 'atlas-shared';

export const JourneyActionOperationalHours = journeyAction({
  ...JourneyActionOperationalHoursBase,
  icon: 'Clock',
});
